import React, { useEffect, useRef } from 'react'
import { Ref, Container, Menu, Segment } from 'semantic-ui-react'
import { ThemeProvider } from 'styled-components'
import { GlobalStyles } from "../../components/GlobalStyles/GlobalStyles"
import { lightTheme, darkTheme } from "../../components/Theme/Theme";
import { useDarkMode } from "../../hooks/useDarkMode/useDarkMode";
import { useSelector, useDispatch } from 'react-redux';
import { SetFixed, SetShowSearchBox } from "../../../../redux/actions/mainActions"
import NavigationBar from "../../containers/Layout1/NavigationBar/NavigationBar"
import Footer from '../../components/Footer/Footer';
import { Outlet } from 'react-router-dom';
import "./Layout2.css"
import AppBar from '../../containers/HomeLayout/AppBar/AppBar';

const Layout2 = ({ children }) => {
  const [theme, themeToggler] = useDarkMode();
  const themeMode = theme === "light" ? lightTheme : darkTheme;
  const dispatch = useDispatch()
  useEffect(() => {
    window.onscroll = function () {
      if (window.pageYOffset === 0) {
        dispatch(SetFixed(false))
        dispatch(SetShowSearchBox(false))

      }
      if (window.pageYOffset > 0) {
        dispatch(SetFixed(true))

      }
    };
  })



  return <React.Fragment>
    <ThemeProvider theme={themeMode}>
      <GlobalStyles />
      <Container fluid className='m-0'>
        <NavigationBar />

        <Container fluid attached='bottom' className="wrap-cls p-5-b">
          <Outlet />
        </Container>
        <AppBar />
        {/*  <Container fluid className="bg-light-grey wrap-cls">
                <Footer/>
              </Container> */}
      </Container>
    </ThemeProvider>
  </React.Fragment>
}
export default Layout2